import { connect } from 'react-redux';

import { fetchUserProfile } from '../actions/user';
import {
  fetchLicenseStatusReset,
  createLicenseStatusReset,
  approveLicenseStatusReset,
  rejectLicenseStatusReset,
  uploadSeedStatusReset,
  fetchContractStatusReset,
  uploadContractStatusReset
} from '../actions/license';

import { fetchUserListStatusReset, updateUserInfoStatusReset } from '../actions/admin';

import { Layout } from '../components/layout';

const mapState = state => ({
  // user
  accessToken: state.user.accessToken,
  isLoggedIn: state.user.isLoggedIn,
  isEmailValid: state.user.isEmailValid,
  isAdmin: state.user.profile.isAdmin,

  // license
  isFetchingFinished: state.license.isFetchingFinished,
  isCreatingFinished: state.license.isCreatingFinished,
  isApprovingFinished: state.license.isApprovingFinished,
  isRejectingFinished: state.license.isRejectingFinished,
  licenseError: state.license.error,

  // seed upload
  isSeedUploadingFinished: state.license.seedUpload.isSeedUploadingFinished,
  seedUploadError: state.license.seedUpload.error,

  // contract
  isContractFetchingFinished: state.license.contract.isContractFetchingFinished,
  isContractUploadingFinished: state.license.contract.isContractUploadingFinished,
  contractError: state.license.contract.error,

  // admin
  isUserListFetchingFinished: state.admin.isUserListFetchingFinished,
  isUserInfoUpdatingFinished: state.admin.isUserInfoUpdatingFinished,
  adminError: state.admin.error
});

const mapDispatch = {
  fetchUserProfile,

  fetchLicenseStatusReset,
  createLicenseStatusReset,
  approveLicenseStatusReset,
  rejectLicenseStatusReset,
  uploadSeedStatusReset,
  fetchContractStatusReset,
  uploadContractStatusReset,

  fetchUserListStatusReset,
  updateUserInfoStatusReset
};

export default connect(
  mapState,
  mapDispatch
)(Layout);
